// After saving some data, lists on backend are not refreshed immediatelly,
// so we need this delay in order to show to user list with all newest items
export const listRefreshDelay = 2000
